// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail-tabs-container {
  width: 100%;
  position: relative;
}

/* Tab Navigation - Pill Style */
.tabs-nav-fixed {
  position: sticky;
  top: 70px;
  z-index: 100;
  background: var(--bg-secondary);
  border-radius: 12px;
  padding: 0.4rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 12px var(--shadow-primary);
  border: 1px solid var(--border-primary);
}

.tabs-nav-wrapper {
  display: flex;
  gap: 0.35rem;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.tabs-nav-wrapper::-webkit-scrollbar {
  display: none;
}

.tab-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.2rem;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;
  min-height: 44px;
  flex: 1;
  justify-content: center;
}

.tab-button:hover {
  color: var(--text-primary);
  background: var(--bg-tertiary);
}

.tab-button.active {
  color: white;
  background: var(--accent-primary);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.tab-icon {
  font-size: 1.1rem;
  line-height: 1;
}

.tab-label {
  font-size: 0.85rem;
  line-height: 1.2;
}

/* Scrollable Content */
.tabs-content-scroll {
  position: relative;
  max-width: 100%;
}

.content-section {
  margin-bottom: 2.5rem;
  scroll-margin-top: 140px;
}

.content-section:last-child {
  margin-bottom: 0;
}

.empty-state {
  padding: 3rem;
  text-align: center;
  color: var(--text-secondary);
}

.empty-state p {
  margin: 0;
  font-size: 1rem;
}

/* Info Section Card */
.info-section-card {
  background: var(--bg-secondary);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid var(--border-primary);
}

.info-section-card.info-section-empty {
  min-height: 80px;
}

.section-heading {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 1.5rem 0;
  font-family: 'Inter', sans-serif;
}

.features-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.feature-item {
  padding: 0.75rem 1rem;
  background: var(--bg-primary);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 0.95rem;
  line-height: 1.5;
  border-left: 3px solid var(--accent-primary);
}

.info-note-box {
  background: var(--bg-primary);
  border-radius: 8px;
  padding: 1rem;
  border-left: 3px solid var(--warning);
}

.info-note-text {
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.6;
  font-style: italic;
}

/* Tablet */
@media (max-width: 900px) {
  .tabs-nav-fixed {
    top: 70px;
  }

  .tab-button {
    padding: 0.5rem 0.8rem;
    font-size: 0.8rem;
  }

  .tab-label {
    font-size: 0.8rem;
  }
}

/* Mobile */
@media (max-width: 680px) {
  .tabs-nav-fixed {
    top: 76px;
    border-radius: 10px;
    padding: 0.3rem;
  }

  .tab-button {
    padding: 0.5rem 0.6rem;
    gap: 0.3rem;
    min-height: 44px;
  }

  .tab-icon {
    font-size: 1rem;
  }

  .tab-label {
    font-size: 0.7rem;
  }

  .content-section {
    margin-bottom: 2rem;
    scroll-margin-top: 120px;
  }

  .info-section-card {
    padding: 1rem;
  }
}

@media (max-width: 400px) {
  .tab-button {
    padding: 0.45rem 0.4rem;
    gap: 0.2rem;
  }

  .tab-label {
    font-size: 0.65rem;
  }

  .tab-icon {
    font-size: 0.9rem;
  }

  .info-section-card {
    padding: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DetailTabs/DetailTabs.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,4CAA4C;EAC5C,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,OAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,WAAW;AACX;EACE;IACE,SAAS;IACT,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".detail-tabs-container {\n  width: 100%;\n  position: relative;\n}\n\n/* Tab Navigation - Pill Style */\n.tabs-nav-fixed {\n  position: sticky;\n  top: 70px;\n  z-index: 100;\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  padding: 0.4rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 2px 12px var(--shadow-primary);\n  border: 1px solid var(--border-primary);\n}\n\n.tabs-nav-wrapper {\n  display: flex;\n  gap: 0.35rem;\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.tabs-nav-wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n.tab-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1.2rem;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  color: var(--text-secondary);\n  font-weight: 600;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  white-space: nowrap;\n  min-height: 44px;\n  flex: 1;\n  justify-content: center;\n}\n\n.tab-button:hover {\n  color: var(--text-primary);\n  background: var(--bg-tertiary);\n}\n\n.tab-button.active {\n  color: white;\n  background: var(--accent-primary);\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);\n}\n\n.tab-icon {\n  font-size: 1.1rem;\n  line-height: 1;\n}\n\n.tab-label {\n  font-size: 0.85rem;\n  line-height: 1.2;\n}\n\n/* Scrollable Content */\n.tabs-content-scroll {\n  position: relative;\n  max-width: 100%;\n}\n\n.content-section {\n  margin-bottom: 2.5rem;\n  scroll-margin-top: 140px;\n}\n\n.content-section:last-child {\n  margin-bottom: 0;\n}\n\n.empty-state {\n  padding: 3rem;\n  text-align: center;\n  color: var(--text-secondary);\n}\n\n.empty-state p {\n  margin: 0;\n  font-size: 1rem;\n}\n\n/* Info Section Card */\n.info-section-card {\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 1px solid var(--border-primary);\n}\n\n.info-section-card.info-section-empty {\n  min-height: 80px;\n}\n\n.section-heading {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 1.5rem 0;\n  font-family: 'Inter', sans-serif;\n}\n\n.features-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n}\n\n.feature-item {\n  padding: 0.75rem 1rem;\n  background: var(--bg-primary);\n  border-radius: 8px;\n  color: var(--text-primary);\n  font-size: 0.95rem;\n  line-height: 1.5;\n  border-left: 3px solid var(--accent-primary);\n}\n\n.info-note-box {\n  background: var(--bg-primary);\n  border-radius: 8px;\n  padding: 1rem;\n  border-left: 3px solid var(--warning);\n}\n\n.info-note-text {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  line-height: 1.6;\n  font-style: italic;\n}\n\n/* Tablet */\n@media (max-width: 900px) {\n  .tabs-nav-fixed {\n    top: 70px;\n  }\n\n  .tab-button {\n    padding: 0.5rem 0.8rem;\n    font-size: 0.8rem;\n  }\n\n  .tab-label {\n    font-size: 0.8rem;\n  }\n}\n\n/* Mobile */\n@media (max-width: 680px) {\n  .tabs-nav-fixed {\n    top: 76px;\n    border-radius: 10px;\n    padding: 0.3rem;\n  }\n\n  .tab-button {\n    padding: 0.5rem 0.6rem;\n    gap: 0.3rem;\n    min-height: 44px;\n  }\n\n  .tab-icon {\n    font-size: 1rem;\n  }\n\n  .tab-label {\n    font-size: 0.7rem;\n  }\n\n  .content-section {\n    margin-bottom: 2rem;\n    scroll-margin-top: 120px;\n  }\n\n  .info-section-card {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 400px) {\n  .tab-button {\n    padding: 0.45rem 0.4rem;\n    gap: 0.2rem;\n  }\n\n  .tab-label {\n    font-size: 0.65rem;\n  }\n\n  .tab-icon {\n    font-size: 0.9rem;\n  }\n\n  .info-section-card {\n    padding: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
